import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { register } from 'swiper/element/bundle';
import { AppModule } from './app/app.module';
import Quill from 'quill';

const SizeStyle = Quill.import('attributors/style/size');
SizeStyle.whitelist = [
  '14px',
  '16px',
  '18px',
  '20px',
  '22px',
  '24px',
  '26px',
  '28px',
];
Quill.register(SizeStyle, true);

register();
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
